import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-header",
  id: "mau_modal_menor_servicio_programado_header"
}
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" })
], -1)
const _hoisted_6 = {
  class: "scroll-y",
  id: "mau_modal_menor_servicio_programado_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#mau_modal_menor_servicio_programado_header",
  "data-kt-scroll-wrappers": "#mau_modal_menor_servicio_programado_scroll",
  "data-kt-scroll-offset": "200px"
}
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = {
  class: "col-lg-12 fw-normal fs-6 mb-4",
  style: {"white-space":"break-spaces"}
}
const _hoisted_10 = { class: "col fv-row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col fv-row fv-plugins-icon-container" }
const _hoisted_13 = { class: "mb-6" }
const _hoisted_14 = {
  class: "col-lg-12 fw-normal fs-6 mb-4",
  style: {"white-space":"break-spaces"}
}
const _hoisted_15 = { class: "col fv-row" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col fv-row fv-plugins-icon-container" }
const _hoisted_18 = { class: "modal-footer flex-center" }
const _hoisted_19 = {
  type: "reset",
  id: "mau_modal_add_oganizacion_cancel",
  class: "btn btn-light me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_20 = ["data-kt-indicator", "disabled"]
const _hoisted_21 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_22 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { useModal } from "@/composable/useModal";
import { hideModal } from "@/core/helpers/dom";
import {
  AuthModule,
  FamiliasListadoModule,
  ServiciosProgramadosModule,
} from "@/store/modules";
import Swal from "sweetalert2";
import { useField, useForm } from "vee-validate";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface FormValues {
  menorId: string;
  servicioProgramadoId: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const module = getModule(FamiliasListadoModule, store);
const serviciosProgramadosModule = getModule(ServiciosProgramadosModule, store);
const authModule = getModule(AuthModule, store);
const { t } = useI18n();
const { modalRef, isShown } = useModal();

onMounted(() => {
  resetForm();
});
watch(isShown, async (value) => {
  if (!value || !module.familia) return;

  resetForm();

  try {
    await Promise.all([
      serviciosProgramadosModule.fetchListado(authModule.user.comarcaId),
      module.fetchMenoresById({
        comarcaId: module.familia.comarcaId,
        id: module.familia.id,
      }),
    ]);
  } catch (err) {
    Swal.fire({
      text: t("formularios.serviciosProgramadosListado.cargar.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  }
});

const serviciosProgramdos = computed(() =>
  serviciosProgramadosModule.servicios.filter((servicio) => {
    return (
      servicio.inscripcionAbierta &&
      new Date(servicio.servicio.finPrevisto) > new Date()
    );
  })
);
const menores = computed(() => module.familia?.menores || []);

const validationSchema = Yup.object({
  menorId: Yup.string()
    .required()
    .label(t("formularios.familiaDetalle.tratamiento.label")),
  servicioProgramadoId: Yup.string()
    .required()
    .label(t("formularios.familiaDetalle.nombre.label")),
});
const { handleSubmit, resetForm, meta } = useForm<FormValues>({
  validationSchema,
});
const { value: menorId } = useField("menorId");
const { value: servicioProgramadoId } = useField("servicioProgramadoId");

const loading = ref(false);
const submit = handleSubmit(async (values) => {
  if (!module.familia?.comarcaId || !module.familia?.id) return;

  try {
    loading.value = true;
    await module.addServioProgramadoMenor({
      comarcaId: !authModule.user.comarcaId
        ? undefined
        : module.familia?.comarcaId,
      familiaId: module.familia?.id,
      ...values,
    });
    await module.fetchServiciosById({
      comarcaId: module.familia?.comarcaId,
      id: module.familia?.id,
    });

    await Swal.fire({
      text: t("dialogs.añadirSolicitudServicioProgramado.success"),
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      heightAuto: false,
      customClass: {
        confirmButton: "btn fw-semobold btn-light-primary",
      },
    });
    hideModal(modalRef.value);
  } catch (error) {
    Swal.fire({
      text: t("dialogs.añadirSolicitudServicioProgramado.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "mau_modal_menor_servicio_programado",
    ref_key: "modalRef",
    ref: modalRef,
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    "aria-label": "Nueva solicitud de servicio programado",
    role: "dialog"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("dialogs.añadirSolicitudServicioProgramado.titulo")), 1),
          _hoisted_5
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t(
                      "dialogs.añadirSolicitudServicioProgramado.menores.label"
                    )), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(menorId),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(menorId) ? (menorId).value = $event : null)),
                        class: "w-100",
                        placeholder: 
                          _ctx.$t(
                            'dialogs.añadirSolicitudServicioProgramado.menores.placeholder'
                          )
                        ,
                        "no-data-text": 
                          _ctx.$t(
                            'dialogs.añadirSolicitudServicioProgramado.menores.noDataText'
                          )
                        ,
                        "popper-class": "w-auto"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menores), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.nombre,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.nombre) + " " + _toDisplayString(item.apellidos), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "no-data-text"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t(
                      "dialogs.añadirSolicitudServicioProgramado.serviciosProgramados.label"
                    )), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(servicioProgramadoId),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(servicioProgramadoId) ? (servicioProgramadoId).value = $event : null)),
                        class: "w-100",
                        placeholder: 
                          _ctx.$t(
                            'dialogs.añadirSolicitudServicioProgramado.serviciosProgramados.placeholder'
                          )
                        ,
                        "no-data-text": 
                          _ctx.$t(
                            'dialogs.añadirSolicitudServicioProgramado.serviciosProgramados.noDataText'
                          )
                        ,
                        "popper-class": "w-auto"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serviciosProgramdos), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.nombre,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.nombre), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "no-data-text"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", _hoisted_19, _toDisplayString(_ctx.$t("dialogs.cancelButton")), 1),
          _createElementVNode("button", {
            "data-kt-indicator": loading.value ? 'on' : null,
            class: "btn btn-lg btn-primary",
            type: "submit",
            disabled: !_unref(meta).valid,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(submit)()))
          }, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("dialogs.add")), 1))
              : _createCommentVNode("", true),
            (loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_ctx.$t("dialogs.addLoading")) + " ", 1),
                  _hoisted_23
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_20)
        ])
      ])
    ])
  ], 512))
}
}

})